module.exports = __webpack_public_path__ + "static/expertise-d4b7f9600c3118b6c15c0f9af6579d94.jpg";